// eslint-disable-next-line import/no-unresolved
import context from 'front-hub-context-api'

export { default as Connect } from './connect'

export { default as withHostContext } from '../../../common/microfrontend/react/with-host-context'

export { default as useHostContext } from '../../../common/microfrontend/react/use-host-context'

export { default as useCommunication } from '../../../common/microfrontend/react/use-communication'

export { default as useFeature } from '../../../common/microfrontend/react/use-feature'

export { default as useAuthorization } from '../../../common/microfrontend/react/use-authorization'

export { default as useInstrumentation } from '../../../common/microfrontend/react/use-instrumentation'

export { useHistory } from '../../../common/microfrontend/react/use-history'

export { default as usePath } from './use-path'

export { default as Image } from './Image'

export { default as Microfrontend } from '../../../common/microfrontend/react/components/Microfrontend'

export { default as Profiler } from './Profiler'

export const FronthubProvider = context.FronthubProvider
export const FronthubConsumer = context.FronthubConsumer
export const FronthubContext = context.FronthubContext
